import ActionButton from './ActionButton.connect';

export default ActionButton;
